/**
 * Filter values that are safe to send.
 *
 * A text box is typed one character at a time, so a control bound straight to
 * a query parameter sends every prefix of what the admin meant. For a year
 * that means `2` goes to an endpoint that only accepts 1950-2100, comes back
 * `422`, and the screen turns into an error before the second digit lands.
 *
 * The rule here is simply: do not filter until the value could be real.
 */

const EARLIEST_YEAR = 1950;
const LATEST_YEAR = 2100;

/**
 * `{ graduation_year }` for a complete, plausible year, `{}` otherwise —
 * spread straight into a params object.
 *
 * The bounds match `GraduationYearFilter` in app/api/v1/admin.py; a value
 * outside them is a half-typed year, not a search for one.
 */
export function graduationYearParam(value) {
  const text = String(value ?? '').trim();
  if (text.length !== 4) return {};
  const year = Number.parseInt(text, 10);
  if (!Number.isInteger(year) || year < EARLIEST_YEAR || year > LATEST_YEAR) return {};
  return { graduation_year: year };
}
